import { Team } from '@yandex-int/k-common/typings';

export const isMesTeam = (team: Team | null | undefined): boolean => {
    return Boolean(team?.external_lms?.mes);
};
